import '@babel/polyfill'
import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import App from './App.vue'
import Code from './views/Code.vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Chart from 'vue2-frappe'

Vue.use(VueAxios, axios);
Vue.use(VueRouter);

Vue.config.productionTip = false
Vue.config.devtools = true

const router = new VueRouter({
	mode: 'history',
	base: window.location.pathName,
	routes: [
		{	
			path: '*',
			component: Code,
			props: true
		}
	]
});

Vue.mixin({
	methods: {
		throttled: (delay, fn) => {
			let lastCall = 0;
			return function (...args) {
				const now = (new Date).getTime();
				if (now - lastCall < delay) {
					return;
				}
				lastCall = now;
				return fn(...args);
			}
		}
	}
});

new Vue({
	vuetify,
	router,
	render: h => h(App)
})
.$mount('#app')

Vue.use(Chart)